import script from "./UserReview.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserReview.vue?vue&type=script&setup=true&lang=ts"

import "./UserReview.vue?vue&type=style&index=0&id=7c0f0578&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c0f0578"]])

export default __exports__